// extracted by mini-css-extract-plugin
export var black = "#01060e";
export var gray = "#e4e4e5";
export var primaryColor = "#015afd";
export var primaryFont = "\"trade-gothic-next\",sans-serif";
export var primaryFontCompressed = "\"trade-gothic-next-compressed\",sans-serif";
export var secondaryFont = "\"Inter\",sans-serif";
export var tertiaryFont = "\"Gantari\",sans-serif";